const te = {
  getHelp: {
    title: 'సహాయం మరియు మద్దతు పొందండి',
    subtitle: 'సహాయం కావాలా? మా జట్టు మీకు సహాయం చేయడానికి ఇక్కడ ఉంది. ఫోన్, ఇమెయిల్ లేదా లైవ్ చాట్ ద్వారా సంప్రదించండి, లేదా మా FAQ లను క్రింద బ్రౌజ్ చేయండి.',
    contactInfo: 'సంప్రదింపు సమాచారం',
    faq: 'తరచుగా అడిగే ప్రశ్నలు',
    faqSubtitle: 'సాధారణ ప్రశ్నలకు సమాధానాలు కనుగొనండి',
    emergency: 'అత్యవసరం',
    emergencyDesc: 'వెంటనే భద్రతా ఆందోళనల కోసం',
    support: 'మద్దతు',
    supportDesc: 'సాధారణ ప్రశ్నలు మరియు సహాయం',
    technical: 'టెక్నికల్',
    technicalDesc: 'యాప్ మరియు వెబ్‌సైట్ సమస్యలు',
    phone: 'ఫోన్',
    email: 'ఇమెయిల్',
    chat: 'లైవ్ చాట్',
    available: '24/7 అందుబాటులో',
    responseTime: '2 గంటల్లో ప్రతిస్పందన',
    responseTimeLong: '24 గంటల్లో ప్రతిస్పందన',
  },
  myIssues: {
    title: 'నా సమస్యలు మరియు ఫిర్యాదులు',
    subtitle: 'మీ నివేదించబడిన సమస్యలు మరియు ఫిర్యాదుల స్థితిని ట్రాక్ చేయండి. తక్షణ సహాయం కోసం, దయచేసి సహాయం పొందండి విభాగాన్ని ఉపయోగించండి.',
    noIssues: 'ఫిర్యాదులు లేదా సమస్యలు కనుగొనబడలేదు.',
    noIssuesDesc: 'మీకు సహాయం కావాలంటే, దయచేసి సహాయం పొందండి విభాగాన్ని ఉపయోగించండి లేదా కొత్త సమస్యను నివేదించండి.',
    issueId: 'సమస్య ఐడి',
    priority: 'ప్రాధాన్యత',
    status: 'స్థితి',
    subject: 'విషయం',
    type: 'రకం',
    filedOn: 'దాఖలు చేయబడింది',
    inProgress: 'ప్రగతిలో',
    resolved: 'పరిష్కరించబడింది',
    closed: 'మూసివేయబడింది',
    high: 'అధిక',
    medium: 'మధ్యస్థ',
    low: 'తక్కువ',
    loading: 'లోడ్ అవుతోంది...',
    error: 'సమస్యలను లోడ్ చేయడంలో లోపం',
  },
  reportIssue: {
    title: 'సమస్యను నివేదించండి',
    subtitle: 'సమస్య ఎదుర్కొంటున్నారా? దయచేసి క్రింద ఫారం నింపండి మరియు మా మద్దతు జట్టు 24-48 గంటల్లో మీతో సంప్రదిస్తుంది.',
    selectIssueType: 'సమస్య రకాన్ని ఎంచుకోండి',
    selectUrgency: 'తక్షణతను ఎంచుకోండి',
    selectOption: 'ఒక ఎంపికను ఎంచుకోండి',
    beforeSubmit: 'సమర్పించేముందు:',
    beforeSubmitPoints: [
      'తక్షణ భద్రతా ఆందోళనల కోసం, దయచేసి అత్యవసర సేవలను కాల్ చేయండి',
      'మీ రైడ్ రసీదు మరియు ఏదైనా సంబంధిత స్క్రీన్‌షాట్‌లను ఉంచండి',
      'మేము 24-48 గంటల్లో ప్రతిస్పందిస్తాము'
    ],
    submitIssue: 'సమస్య నివేదనను సమర్పించండి',
    submitting: 'సమర్పిస్తోంది...',
    success: 'మీ సమస్య విజయవంతంగా సమర్పించబడింది! మా మద్దతు జట్టు త్వరలో దీన్ని పరిష్కరిస్తుంది.',
    error: 'ఏదో తప్పు జరిగింది. దయచేసి తర్వాత మళ్లీ ప్రయత్నించండి.',
    loading: 'లోడ్ అవుతోంది...',
  },
  common: {
    loading: 'లోడ్ అవుతోంది...',
    error: 'లోపం',
    success: 'విజయం',
    submit: 'సమర్పించండి',
    cancel: 'రద్దు',
    back: 'వెనుక',
    next: 'తదుపరి',
    save: 'సేవ్ చేయండి',
    edit: 'సవరించండి',
    delete: 'తొలగించండి',
    close: 'మూసివేయండి',
    open: 'తెరవండి',
    yes: 'అవును',
    no: 'లేదు',
    required: 'అవసరం',
    optional: 'ఐచ్ఛికం',
  },
  aboutYou: {
    basicInfo: "ప్రాథమిక సమాచారం",
    firstName: "మొదటి పేరు",
    lastName: "చివరి పేరు",
    gender: "లింగం",
    male: "పురుషుడు",
    female: "స్త్రీ",
    parent: 'తల్లిదండ్రులు',
    spouse: 'భర్త/భార్య',
    sibling: 'సోదరుడు/సోదరి',
    friend: 'స్నేహితుడు',
    other: "ఇతర",
    preferNotToSay: "చెప్పకూడదు",
    dateOfBirth: "పుట్టిన తేది",
    contactInfo: "సంప్రదింపు సమాచారం",
    email: "ఇమెయిల్ చిరునామా",
    phoneNumber: "ఫోన్ నంబర్",
    addressInfo: "చిరునామా సమాచారం",
    address: "చిరునామా",
    city: "నగరం",
    state: "రాష్ట్రం",
    pincode: "పిన్ కోడ్",
    emergencyContact: "అత్యవసర సంప్రదింపు",
    emergencyContactNumber: "సంప్రదింపు నంబర్",
    relationship: "సంబంధం",
    selectRelationship: "సంబంధాన్ని ఎంచుకోండి",
   
    saveProfile: "ప్రొఫైల్ సమాచారాన్ని సేవ్ చేయండి",
    phFirstName: "మొదటి పేరు నమోదు చేయండి",
    phLastName: "చివరి పేరు నమోదు చేయండి",
    phEmail: "ఇమెయిల్ చిరునామా నమోదు చేయండి",
    phPhone: "ఫోన్ నంబర్ నమోదు చేయండి",
    phAddress: "మీ చిరునామా నమోదు చేయండి",
    phCity: "నగరం నమోదు చేయండి",
    phState: "రాష్ట్రం నమోదు చేయండి",
    phPincode: "పిన్ కోడ్ నమోదు చేయండి",
    phEmergencyContact: "అత్యవసర సంప్రదింపు నంబర్ నమోదు చేయండి",
    save: 'సేవ్ చేయండి',
    edit: 'సవరించండి',
    firstNameRequired: 'మొదటి పేరు అవసరం.',
    firstNameInvalid: 'మొదటి పేరు అక్షరాలు, ఖాళీలు, అపోస్ట్రోఫీలు లేదా హైఫన్‌లతో మాత్రమే ఉండాలి.',
    lastNameRequired: 'చివరి పేరు అవసరం.',
    lastNameInvalid: 'చివరి పేరు అక్షరాలు, ఖాళీలు, అపోస్ట్రోఫీలు లేదా హైఫన్‌లతో మాత్రమే ఉండాలి.',
    emailRequired: 'ఈమెయిల్ అవసరం.',
    emailInvalid: 'దయచేసి సరైన ఈమెయిల్ చిరునామాను నమోదు చేయండి.',
    phoneRequired: 'ఫోన్ నంబర్ అవసరం.',
    phoneInvalid: 'ఫోన్ నంబర్ 10 నుండి 15 అంకెల మధ్య ఉండాలి.',
    dobRequired: 'పుట్టిన తేదీ అవసరం.',
    dobInvalid: 'దయచేసి సరైన పుట్టిన తేదీని నమోదు చేయండి (YYYY-MM-DD).',
    genderRequired: 'లింగం అవసరం.',
    addressRequired: 'చిరునామా అవసరం.',
    cityRequired: 'నగరం అవసరం.',
    cityInvalid: 'నగరం అక్షరాలు, ఖాళీలు, అపోస్ట్రోఫీలు లేదా హైఫన్‌లతో మాత్రమే ఉండాలి.',
    stateRequired: 'రాష్ట్రం అవసరం.',
    stateInvalid: 'రాష్ట్రం అక్షరాలు, ఖాళీలు, అపోస్ట్రోఫీలు లేదా హైఫన్‌లతో మాత్రమే ఉండాలి.',
    countryRequired: 'దేశం అవసరం.',
    countryInvalid: 'దేశం అక్షరాలు, ఖాళీలు, అపోస్ట్రోఫీలు లేదా హైఫన్‌లతో మాత్రమే ఉండాలి.',
    pincodeRequired: 'పిన్‌కోడ్ అవసరం.',
    pincodeInvalid: 'పిన్‌కోడ్ 4 నుండి 10 అంకెల మధ్య ఉండాలి.',
    emergencyContactRequired: 'అత్యవసర సంప్రదింపు నంబర్ అవసరం.',
    emergencyContactInvalid: 'అత్యవసర సంప్రదింపు నంబర్ 10 నుండి 15 అంకెల మధ్య ఉండాలి.',
    relationshipRequired: 'సంబంధం అవసరం.',
    relationshipInvalid: 'దయచేసి అత్యవసర సంప్రదింపుకు సరైన సంబంధాన్ని ఎంచుకోండి.',
    emergencyCountryCodeRequired: 'అత్యవసర దేశ కోడ్ అవసరం.',
    fixErrorsBeforeSaving: 'దయచేసి హైలైట్ చేసిన ఫీల్డ్స్‌ను పరిశీలించి, ప్రొఫైల్ సేవ్ చేయడానికి ముందు అన్ని లోపాలను సరిచూడండి.',
  },
  account: {
    goodMorning: "శుభోదయం",
    goodAfternoon: "శుభ మద్యాహ్నం",
    goodEvening: "శుభ సాయంత్రం",
    completeIdentity: "మీ గుర్తింపును ధృవీకరించండి",
    addEmergencyContact: "అత్యవసర సంప్రదింపు వివరాలు జోడించండి",
    uploadDriverLicense: "రైడర్ ప్రొఫైల్ కోసం డ్రైవర్ లైసెన్స్‌ను అప్‌లోడ్ చేయండి",
    aboutYou: "మీ గురించి",
    aboutYouDesc: "మీ గురించి చెప్పండి",
    identityVerification: "గుర్తింపు ధృవీకరణ",
    identityVerificationDesc: "మీ గుర్తింపును ధృవీకరించండి",
    offerRides: "రైడ్‌లను ఆఫర్ చేయండి",
    offerRidesDesc: "మీ డ్రైవర్ ప్రొఫైల్‌ను సెటప్ చేయండి",
    findRides: "రైడ్‌లు కనుగొనండి",
    findRidesDesc: "మీ ప్రయాణ ప్రాధాన్యతలు",
    appSettings: "యాప్ సెట్టింగ్స్",
    appSettingsDesc: "మీ అనుభవాన్ని అనుకూలీకరించండి",
    walletPayments: "వాలెట్ & చెల్లింపులు",
    walletPaymentsDesc: "మీ డబ్బును నిర్వహించండి",
    supportGrievances: "మద్దతు & ఫిర్యాదులు",
    supportGrievancesDesc: "మద్దతు పొందండి లేదా ఫిర్యాదు చేయండి",
    actionRequired: "చర్య అవసరం",
    completeProfile: "మీ ప్రొఫైల్‌ను పూర్తి చేయండి",
    profileHelp: "మీ ప్రొఫైల్‌ను పూర్తి చేయడం ద్వారా మీకు సరైన రైడ్‌లను కనుగొనడంలో మా AIకి సహాయపడండి!",
  },
  settings: {
    appSettings: 'యాప్ సెట్టింగ్స్',
    appSettingsDesc: 'మీ Duri  అనుభవాన్ని అనుకూలీకరించండి మరియు మీ గోప్యత ప్రాధాన్యతలను నిర్వహించండి.',
    languageRegion: 'భాష & ప్రాంతం',
    languagePrompt: 'మీరు ఏ భాషను ఇష్టపడతారు?',
    timezone: 'సమయ మండలం',
    currency: 'కరెన్సీ',
    appPermissions: 'యాప్ అనుమతులు',
    appPermissionsDesc: 'ఈ అనుమతులు మీకు ఉత్తమ రైడ్ అనుభవాన్ని అందించడంలో మాకు సహాయపడతాయి. మీరు వీటిని ఎప్పుడైనా మార్చవచ్చు.',
    locationAccess: 'స్థానాన్ని యాక్సెస్ చేయండి',
    locationAccessDesc: 'సమీపంలోని రైడ్స్ చూపించడానికి మరియు నావిగేషన్ అందించడానికి మాకు అనుమతించండి',
    readSmsOtp: 'SMS/OTP చదవండి',
    readSmsOtpDesc: 'త్వరిత ధృవీకరణ కోసం OTP కోడ్‌లను ఆటో-ఫిల్ చేయండి',
    phoneCalls: 'ఫోన్ కాల్స్',
    phoneCallsDesc: 'కోఆర్డినేషన్ కోసం రైడర్స్/ట్రావెలర్స్‌ను కాల్ చేయడానికి అనుమతించండి',
    notifications: 'నోటిఫికేషన్స్',
    notificationsDesc: 'మీ రైడ్స్ మరియు Duri  వార్తల గురించి ఎలా అప్డేట్ అవ్వాలో ఎంచుకోండి.',
    pushNotifications: 'పుష్ నోటిఫికేషన్స్',
    pushNotificationsDesc: 'రైడ్ అప్డేట్స్, సందేశాలు మరియు ముఖ్యమైన అలర్ట్స్',
    emailNotifications: 'ఈమెయిల్ నోటిఫికేషన్స్',
    emailNotificationsDesc: 'ఈమెయిల్ ద్వారా రైడ్ నిర్ధారణలు మరియు రసీదులు',
    smsNotifications: 'SMS నోటిఫికేషన్స్',
    smsNotificationsDesc: 'టెక్స్ట్ సందేశం ద్వారా ముఖ్యమైన రైడ్ అప్డేట్స్',
    rideReminders: 'రైడ్ రిమైండర్స్',
    rideRemindersDesc: 'రాబోయే రైడ్స్ గురించి రిమైండర్స్',
    promotionalUpdates: 'ప్రోమోషనల్ అప్డేట్స్',
    promotionalUpdatesDesc: 'ప్రత్యేక ఆఫర్లు మరియు కొత్త ఫీచర్లు',
    saveSettings: 'సెట్టింగ్స్ సేవ్ చేయండి',
  },
  header: {
    home: 'హోమ్',
    findRide: 'రైడ్ కనుగొనండి',
    offerRide: 'రైడ్ ఆఫర్ చేయండి',
    manageRides: 'రైడ్స్ నిర్వహించండి',
    account: 'ఖాతా',
    logout: 'లాగ్ అవుట్',
    aiAssistant: 'చలో AI అసిస్టెంట్',
    findPerfectRideMatch: 'మీకు సరిపోయే రైడ్‌ను కనుగొనండి',
    connectWithTravelers: 'మీ మార్గంలో ప్రయాణికులతో కనెక్ట్ అవ్వండి',
    askAiFindingRides: 'రైడ్‌లను కనుగొనడంపై AIని అడగండి...',
    askAiOfferingRides: 'రైడ్ ఆఫర్ చేయడంపై AIని అడగండి...',
    findRidesToBandra: 'బాంద్రాకు రైడ్‌లు కనుగొనండి',
    cheapestRouteToAirport: 'ఎయిర్‌పోర్ట్‌కు చౌకైన మార్గం',
    dailyCommuteToPowai: 'పోవైకి రోజువారీ ప్రయాణం',
    postRideToGurgaon: 'గుర్గావ్‌కు రైడ్ పోస్ట్ చేయండి',
    setRecurringRoute: 'పునరావృత మార్గాన్ని సెట్ చేయండి',
    managePassengers: 'ప్రయాణికులను నిర్వహించండి',
    benefits: 'ప్రయోజనాలు',
    howItWorks: 'ఇది ఎలా పనిచేస్తుంది',
    findARide: 'రైడ్ కనుగొనండి',
    safety: 'భద్రత',
    support: 'సహాయం',
    login: 'లాగిన్',
    getStarted: 'ప్రారంభించండి',
    },
  appStore: {
        title: 'Get Our Mobile App',
        description: 'Experience the best ride-sharing on the go. Download now for live tracking, instant notifications, and seamless booking.',
        getItOn: 'DOWNLOAD IN',
        googlePlay: 'Google Play',
        downloadOnThe: 'DOWNLOAD IN',
        appStore: 'App Store',
        thanksForJoining: 'మా కమ్యూనిటీలో చేరినందుకు ధన్యవాదాలు!',
        communityMessage1: 'రైడ్ షేరింగ్‌లో కొత్త అనుభవాన్ని ఇప్పుడే అనుభవించండి',
        communityMessage2: 'మా యాప్‌ను ఇప్పుడే డౌన్‌లోడ్ చేసుకోండి వేలాది ప్రయాణికులతో కలిసి ప్రయాణాన్ని మొదలుపెట్టండి',
        ctaMessage: 'Available on iOS and Android • Free to download',
        featuresTitle: 'ఈరోజే ప్లాన్ చేసుకోండి, ప్రతి సెలబ్రేషన్‌ని ఎంజాయ్ చేయండి',
        featuresSubtitle: ' పరిశీలించబడిన గెస్ట్‌లు మరియు హోస్ట్‌లతో సురక్షితంగా, నమ్మకంగా చేసే ప్రయాణం',
        liveTrackingTitle: 'సిటీ టు సిటీ రైడ్స్',
        liveTrackingDesc: 'Track your ride in real-time with GPS.',
        sosSupportTitle: 'షేర్ కాస్ట్',
        sosSupportDesc: '24/7 emergency support at your fingertips.',
        perSeatPriceTitle: 'పర్ సీట్ బుకింగ్',
        perSeatPriceDesc: 'Pay only for your seat. Transparent pricing.',
        privatevehicle: 'ప్రైవేట్ వెహికల్',
        privatevehicleDesc: 'Travel in your own car with your own driver.',
        dailyCommuteCarpoolTitle: 'డైలీ కమ్యూట్ కార్‌పూల్',
        dailyCommuteCarpoolDesc: 'ఆఫీస్ ప్రయాణాన్ని ధృవీకరించబడిన సహ ప్రయాణికులతో పంచుకోండి.',
        verifiedCommunityTitle: 'Verified Community',
        verifiedCommunityDesc: 'Travel with verified hosts and guests. Our safety-first approach ensures peace of mind on every journey.',
        anytimeRidesTitle: 'Rides Anytime',
        anytimeRidesDesc: 'Find rides 24/7. Whether it\'s early morning or late night, connect with travelers going your way.',
        instantBookingTitle: 'Instant Booking',
        instantBookingDesc: 'Book your ride in seconds. Quick confirmation and seamless payment process for hassle-free travel.',
        firstRideOfferBadge: '50% OFF',
        firstRideOfferTitle: 'మీ మొదటి రైడ్‌పై!',
        firstRideOfferDesc: 'డ్యూరీకి కొత్తా? మీ మొదటి రైడ్‌పై 50% డిస్కౌంట్ పొందండి!',
        referralRewardTitle: 'బహుళ రివార్డ్స్ సంపాదించండి!',
        referralRewardDesc: 'మీ ఆన్‌బోర్డింగ్ పూర్తి చేసి ₹125 పొందండి మరియు ప్రతి విజయవంతమైన రెఫరల్‌కు ₹100 సంపాదించండి. ఈ రోజు సంపాదించడం ప్రారంభించండి!',
        onboardingRewardTitle: 'ఆన్‌బోర్డింగ్ రివార్డ్',
        onboardingRewardDesc: 'మీరు నమోదు చేసి, పత్రాలను అప్‌లోడ్ చేసి, ధృవీకరించబడి, కనీసం ఒక గెస్ట్‌తో కలిసి మీ మొదటి హోస్ట్ చేసిన రైడ్ పూర్తి చేసినప్పుడు ₹125 సంపాదించండి.',
        referralProgramTitle: 'రెఫరల్ రివార్డ్',
        referralProgramDesc: 'ప్రతి స్నేహితుడు యాప్‌ని ఇన్‌స్టాల్ చేసి, మీ నంబర్‌ని ఎంటర్ చేసి, పత్రాలను అప్‌లోడ్ చేసి, ధృవీకరించబడి, వారి మొదటి హోస్ట్ చేసిన రైడ్ పూర్తి చేసినప్పుడు ₹100 సంపాదించండి.',
        limitedTimeOffer: 'Limited Time Offer',
        noCodeNeeded: 'No Code Needed',
        applyAutomatically: 'Applies Automatically',
    },
  footer: {
    downloadAppTitle: 'Duri డౌన్‌లోడ్ చేయండి',
    downloadAppDesc: 'ఉత్తమ అనుభవం కోసం మొబైల్ యాప్‌ను పొందండి, లైవ్ ట్రాకింగ్, తక్షణ నోటిఫికేషన్లు మరియు ఎక్కడైనా రైడ్ బుకింగ్. అన్ని పరికరాల్లో ఉచితంగా అందుబాటులో ఉంది.',
    getItOn: 'దీనిపై పొందండి',
    googlePlay: 'గూగుల్ ప్లే',
    downloadOnThe: 'డౌన్‌లోడ్ చేయండి',
    appStore: 'యాప్ స్టోర్',
    scanForAndroid: 'Android కోసం స్కాన్ చేయండి',
    scanForIOS: 'iOS కోసం స్కాన్ చేయండి',
    googlePlayStore: 'గూగుల్ ప్లే స్టోర్',
    appleAppStore: 'ఆపిల్ యాప్ స్టోర్',
    brandDesc: 'స్మార్ట్, సురక్షిత మరియు సుస్థిర రైడ్ షేరింగ్ ద్వారా ప్రపంచవ్యాప్తంగా ప్రయాణికులను కలుపుతుంది. ప్రయాణాన్ని మెరుగుపరిచిన లక్షల మందిలో చేరండి, డబ్బు ఆదా చేయండి మరియు మా ప్లానెట్ని రక్షించండి.',
    contactEmail: 'contact@hansaitechnosoft.com',
    contactPhone: '+91 76809 38741',
    contactHours: 'Available hrs: 8 AM to 10 PM IST',
    availableCountries: '25+ దేశాల్లో అందుబాటులో ఉంది',
    sectionCompany: 'కంపెనీ',
    sectionGuests: 'గెస్ట్ కోసం',
    sectionHosts: 'హోస్ట్‌ల కోసం',
    sectionTravelers: 'ప్రయాణికుల కోసం',
    sectionSupport: 'సహాయం మరియు మద్దతు',
    sectionLegal: 'న్యాయ మరియు అనుపాలన',
    sectionCountries: 'అందుబాటులో ఉన్న దేశాలు',
    companyLinks: {
      aboutUs: 'మా గురించి',
      news: 'వార్తలు & అప్‌డేట్‌లు',
      howItWorks: 'ఇది ఎలా పనిచేస్తుంది',
      safety: 'భద్రత',
      careers: 'కెరీయర్స్',
      press: 'ప్రెస్',
      duriGreenMobility: 'డ్యూరి గ్రీన్ మొబిలిటీ',
    },
    guestLinks: {
      howToBook: 'రైడ్ ఎలా బుక్ చేయాలి?',
      findARide: 'రైడ్ కనుగొనండి',
      availableRides: 'అందుబాటులో ఉన్న రైడ్‌లు',
      searchByRideId: 'రైడ్ Id తో వెతకండి',
      searchByRider: 'రైడర్ తో వెతకండి',
      howToBookGuide: 'రైడ్ ఎలా బుక్ చేయాలి',
      howToDailyCommute: 'డైలీ కమ్యూట్ ఎలా',
      commuteCalculator: 'కమ్యూట్ కాలిక్యులేటర్ (గెస్ట్)',
    },
    hostLinks: {
      howToHost: 'రైడ్ ఎలా హోస్ట్ చేయాలి?',
      rideRequests: 'రైడ్ అభ్యర్థనలు',
      lookUpARide: 'రైడ్ చూడండి',
      howToDailyCommute: 'డైలీ కమ్యూట్ ఎలా',
      popularRoutes: 'ప్రాచుర్యం పొందిన రైడ్‌లు',
      commuteCalculator: 'కమ్యూట్ కాలిక్యులేటర్ (హోస్ట్)',
    },
    travelersLinks: {
      findRides: 'రైడ్‌లు కనుగొనండి',
      offerRides: 'రైడ్‌లు ఆఫర్ చేయండి',
      mobileApp: 'మొబైల్ యాప్',
      referFriends: 'స్నేహితులను సూచించండి',
      helpCenter: 'సహాయ కేంద్రం'
    },
    supportLinks: {
      customerSupport: 'కస్టమర్ సపోర్ట్',
      safetyGuidelines: 'భద్రతా మార్గదర్శకాలు',
      trustSafety: 'నమ్మకం & భద్రత',
      insurance: 'ఇన్సూరెన్స్',
      contactUs: 'మమ్మల్ని సంప్రదించండి',
      getHelp: 'సహాయం పొందండి',
      reportIssue: 'సమస్యను నివేదించండి',
      myIssues: 'నా సపోర్ట్ టికెట్లు',
      whatsappSupport: 'WhatsApp సపోర్ట్',
      corporateCarpool: 'కార్పొరేట్ కార్‌పూల్',
    },
    legalLinks: {
      termsOfService: 'నిబంధనలు మరియు షరతులు',
      privacyPolicy: 'గోప్యతా విధానం',
      cookiePolicy: 'కుకీ విధానం',
      refundPolicy: 'రద్దు విధానం',
      deleteAccount: 'ఖాతా తొలగించు',
      tripInsurance: 'ట్రిప్ ఇన్సూరెన్స్',
      paymentTerms: 'చెల్లింపు నిబంధనలు మరియు షరతులు',
      communityGuidelines: 'సముదాయ మార్గదర్శకాలు'
    },
    copyright: '© 2025 Duri. అన్ని హక్కులు పరిరక్షించబడ్డాయి.',
    copyrightText: '@{year} HansAI Techno Soft Private Limited, అన్ని హక్కులు పరిరక్షించబడ్డాయి'
  },
  quickRideFinder: {
    currentLocationDetected: '📍 ప్రస్తుత స్థానం గుర్తించబడింది',
    greeting1: '👋 హాయ్! మీరు {location} లో ఉన్నారు.',
    greeting2: 'ఈ రోజు మీరు ఎక్కడికి వెళ్లాలనుకుంటున్నారు?',
    letsFindRide: 'రైడ్‌ను కనుగొనదాం! ✨',
    destinationPrompt: '🎯 బాగుంది! మనం ఎక్కడికి వెళ్ళాలి?',
    destinationSubPrompt: 'మీ గమ్యస్థానాన్ని టైప్ చేయండి లేదా క్రింద ఉన్న ప్రజాదరణ పొందిన ఎంపికల నుండి ఎంచుకోండి',
    destinationPlaceholder: 'ఉదా., పుణె, ఢిల్లీ, బెంగళూరు...',
    nextWhen: 'తర్వాత: ఎప్పుడు? →',
    datePrompt: '📅 మంచి ఎంపిక! {from} నుండి {to}',
    dateSubPrompt: 'మీరు ఎప్పుడు ప్రయాణించాలనుకుంటున్నారు?',
    nextPassengers: 'తర్వాత: ఎంత మంది ప్రయాణికులు? →',
    passengersPrompt: '👥 ఇంకొద్దిసేపే! ఎంత మంది ప్రయాణికులు?',
    passengersSubPrompt: 'మీరు సహా',
    perfectFindRides: 'బాగుంది! రైడ్స్‌ను కనుగొనదాం →',
    readyTitle: '🎉 వెతకడానికి సిద్ధంగా ఉంది!',
    from: 'నుండి:',
    to: 'వరకు:',
    date: 'తేదీ:',
    passengers: 'ప్రయాణికులు:',
    person: 'వ్యక్తి',
    people: 'వ్యక్తులు',
    findMyPerfectRide: 'నా పరిపూర్ణ రైడ్‌ను కనుగొనండి!',
      popularRoutes: 'ముంబై నుండి ప్రజాదరణ పొందిన మార్గాలు', // '{city} నుండి ప్రజాదరణ పొందిన మార్గాలు',
    today: 'ఈ రోజు',
    tomorrow: 'రేపు',
    thisWeekend: 'ఈ వారాంతం',
    locationNotFoundLabel: '📍 స్థానం కనుగొనబడలేదు',
    locationNotFoundMessage: 'దయచేసి స్థానాన్ని యాక్సెస్ చేయడానికి అనుమతించండి లేదా ప్రారంభించడానికి మీ స్థానాన్ని మానవీయంగా నమోదు చేయండి!',
  },
  hero: {
    badge: 'మా ప్లాట్‌ఫారమ్‌పై గెస్ట్‌లు మరియు హోస్ట్‌ల ద్వారా నమ్మకం ఏర్పడింది',
    mainTitle: 'రైడ్ పంచుకోండి',
    mainTitleHighlight: 'వాలెట్ మరియు ప్లానెట్ని రక్షించండి.',
    subtitle: 'అత్యంత నమ్మకమైన అంతరనగర రైడ్‌షేరింగ్‌ యాప్‌లో చేరండి — మీ రైడ్‌ను పంచుకోండి, మరింత ఆదా చేయండి, మరియు తెలివిగా ప్రయాణించండి.',
    findRide: 'రైడ్ కనుగొనండి',
    offerRide: 'రైడ్ ఆఫర్ చేయండి',
    statSaved: 'మొత్తం సేవ్ చేయబడింది',
    statCO2: 'CO₂ టన్నులు తగ్గించబడ్డాయి',
      statHappy: 'సంతోషకరమైన ప్రయాణాలు',
      'City to City Rides':'సిటీ టు సిటీ రైడ్స్',
      'Ride Between Cities': 'సిటీల మధ్య ట్రావెల్ చేయండి',
      'Share Cost': 'షేర్ కాస్ట్',
      'Share to Save': 'షేర్ చేస్తే డబ్బు సేవ్ అవుతుంది',
      'Per Seat Booking': 'పర్ సీట్ బుకింగ్',
      'Reserve Your Seat':'  మీ సీటు ముందుగానే బుక్ చేసుకోండి',
      'Private Vehicles': 'ప్రైవేట్ వెహికల్',
      'Private & Comfortable': 'ప్రైవేట్, కంఫర్టబుల్ జర్నీ',
      privateVehicles: 'ప్రైవేట్ వెహికల్',
      privateComfortable: 'ప్రైవేట్, కంఫర్టబుల్ జర్నీ',
      dailyCommuteCarpool: 'డైలీ కమ్యూట్ కార్‌పూల్',
      cityToCityRides: 'సిటీ టు సిటీ రైడ్స్',
      rideBetweenCities: 'సిటీల మధ్య ట్రావెల్ చేయండి',
      shareCost: 'షేర్ కాస్ట్',
      shareToSave: 'షేర్ చేస్తే డబ్బు సేవ్ అవుతుంది',
      perSeatBooking: 'పర్ సీట్ బుకింగ్',
      reserveYourSeat: 'మీ సీటు ముందుగానే బుక్ చేసుకోండి',
  },
  benefits: {
    badge: 'ఎందుకు Duri?',
    sectionTitle: 'మీకు కావాల్సిన ప్రతిదీ',
    sectionSubtitle: 'స్మార్ట్, సురక్షిత, మరియు స్థిరమైన ప్రయాణానికి.',
    saveMoneyTitle: 'డబ్బు సేవ్ చేయండి',
    saveMoneyDesc: 'తక్కువ ఖర్చుతో కూడిన రైడ్‌షేరింగ్‌ ఎంపికలతో బడ్జెట్‌ ప్రయాణాన్ని ఆస్వాదించండి, ఇవి ఖర్చులను 70% వరకు తగ్గిస్తాయి',
    saveMoneyStats: 'రైడ్ షేరింగ్‌తో ఏడాదికి ₹15,000 వరకు సేవ్ చేయండి',
    helpPlanetTitle: 'ప్లానెట్‌ను రక్షించండి',
    helpPlanetDesc: 'ప్రతి షేర్‌డ్‌ ట్రావెల్‌ యాప్‌ రైడ్‌తో CO₂ని తగ్గించండి మరియు పచ్చటి ప్రయాణ పరిష్కారాన్ని ఎంచుకోండి',
    helpPlanetStats: 'ప్రతి 100కిమీకి 2.3 కిలో CO₂ సేవ్',
    travelSafeTitle: 'సురక్షితంగా ప్రయాణించండి',
    travelSafeDesc: 'ధృవీకరించబడిన హోస్ట్‌లు మరియు రియల్‌టైమ్‌ రైడ్‌ ట్రాకింగ్‌తో నమ్మకమైన కార్‌పూల్‌ యాప్‌',
    travelSafeStats: '99.8% ప్రమాద రహిత రైడ్స్',
    anyTimeTitle: 'ఎప్పుడైనా',
    anyTimeDesc: 'మా రియల్‌టైమ్‌ నావిగేషన్‌ యాప్‌తో ఎప్పుడైనా సిటీ-టు-సిటీ రైడ్‌లను యాక్సెస్‌ చేయండి',
    anyTimeStats: 'ఎప్పుడైనా అందుబాటులో',
    meetPeopleTitle: 'ప్రజలను కలవండి',
    meetPeopleDesc: 'మా పెరుగుతున్న రైడ్ షేరింగ్ కమ్యూనిటీ ద్వారా కనెక్ట్ అయ్యి కలిసి ప్రయాణించండి',
    meetPeopleStats: '85% యూజర్లు కనెక్షన్స్ చేసుకున్నారు',
    goAnywhereTitle: 'ఎక్కడికైనా వెళ్లండి',
    goAnywhereDesc: 'బహుళ దేశాల్లో 500+ గమ్యస్థానాలకు యాక్సెస్',
    goAnywhereStats: 'ప్రపంచవ్యాప్తంగా 500+ నగరాలు',
  },
  statistics:{
    sectionTitle: "రైడ్‌షేరింగ్ గణాంకాలు",
  sectionSubtitle: "ప్రపంచవ్యాప్తంగా ప్రయాణికులకు మేము అందిస్తున్న ప్రభావాన్ని చూడండి.",
  travelersLabel: "ప్రయాణికులు",
  travelersDesc: "రైడ్‌షేరింగ్‌ను ప్రపంచవ్యాప్తంగా నమ్ముతున్నారు",
  citiesLabel: "నగరాలు",
  citiesDesc: "మేము సేవలు అందిస్తున్నవి",
  savedLabel: "మొత్తం ఆదా",
  savedDesc: "ప్రయాణ ఖర్చులో",
  co2Label: "CO₂ తగ్గింపు",
  co2Desc: "ఉద్గారాలను తగ్గించండి — పరమ కార్బన్‌ ఆదా చేసే ప్రయాణ పరిష్కారం",
  costReductionLabel: "ఖర్చు తగ్గింపు",
  costReductionSuffix: "% తక్కువ ఖర్చు",
  emissionReductionLabel: "ఉద్గార తగ్గింపు",
  emissionReductionSuffix: "% తక్కువ CO₂",
  userSatisfactionLabel: "వినియోగదారు సంతృప్తి",
  userSatisfactionSuffix: "% సంతోషంగా ఉన్నవారు",
  safetyRateLabel: "భద్రత రేటు",
  safetyRateSuffix: "% భద్రతా రేటు"
  },
  safety:{
    badge: "భద్రత",
  sectionTitle: "మీ",
  sectionTitleHighlight: "భద్రత మా ప్రాధాన్యత",
  sectionSubtitle: "సురక్షితమైన ప్రయాణం, నమ్మకమైన మరియు అనుకూలమైన రైడ్ అనుభవాలను నిర్ధారించడానికి మా నమ్మకమైన రైడ్ షేరింగ్ యాప్‌లో ప్రతి యూజర్ ధృవీకరించబడినవారు.",
  backgroundVerified: "బ్యాక్‌గ్రౌండ్ వెరిఫైడ్",
  safeRidesCompleted: "సురక్షిత ప్రయాణాలు",
  trustScoreAverage: "నమ్మక స్కోర్ సగటు",
  emergencyResponse: "అత్యవసర స్పందన",
  idVerificationTitle: "ఐడెంటిటీ ధృవీకరణ",
  idVerificationDesc: "ప్రతి ప్రయాణికుడు మరియు డ్రైవర్ యొక్క గుర్తింపు ధృవీకరించబడుతుంది.",
  idVerificationStats: "100% KYC పూర్తయింది",
  professionalTitle: "ప్రొఫెషనల్ డ్రైవర్లు",
  professionalDesc: "అనుభవజ్ఞులైన మరియు శిక్షణ పొందిన డ్రైవర్లు మాత్రమే.",
  professionalStats: "90% డ్రైవర్లు ప్రొఫెషనల్",
  cultureTitle: "సాంస్కృతిక వైవిధ్యం",
  cultureDesc: "వివిధ నేపథ్యాల నుండి ప్రయాణికులు మరియు డ్రైవర్లు.",
  cultureStats: "30+ భాషలు మాట్లాడే వారు",
  interestsTitle: "సామాన్య ఆసక్తులు",
  interestsDesc: "మీ ఆసక్తులకు అనుగుణంగా ప్రయాణ భాగస్వాములు.",
  interestsStats: "80% మ్యాచ్ రేట్",
  trackingTitle: "ప్రత్యక్ష ట్రాకింగ్",
  trackingDesc: "ప్రతి ప్రయాణానికి రియల్‌టైమ్ రైడ్ ట్రాకింగ్ మరియు స్మార్ట్ మొబిలిటీ సొల్యూషన్స్‌తో సురక్షితంగా ఉండండి.",
  trackingStats: "24/7 ట్రాకింగ్",
  secureCommTitle: "సురక్షిత కమ్యూనికేషన్",
  secureCommDesc: "ధృవీకరించబడిన హోస్ట్‌లు మరియు అతిథుల కోసం మా యాప్‌లో సురక్షితమైన కమ్యూనికేషన్‌ను ఆస్వాదించండి — గోప్యతా హామీ.",
  secureCommStats: "ఎండ్-టు-ఎండ్ ఎన్‌క్రిప్షన్",
  ctaTitle: "మా భద్రతా ప్రమాణాలను అనుభవించండి",
  ctaDesc: "మీరు ప్రయాణించేటప్పుడు మేము మీ భద్రతను నిర్ధారిస్తాము.",
  ctaButton: "ఇప్పుడే చేరండి"
  },
  howItWorks: {
  sectionTitle: "ఇది ఎలా పనిచేస్తుంది?",
  sectionSubtitle: "మీ ప్రయాణ అనుభవాన్ని మార్చే నాలుగు సులభమైన స్టెప్స్ —హోస్ట్‌గా",
  searchTitle: "మీ రైడ్‌ని లిస్ట్ చేయండి",
  searchDesc: "కొన్ని క్లిక్‌లలో మీ ఖాళీ సీట్లు మరియు రూట్లను గెస్ట్లకు చూపించండి.",
  connectTitle: "కనెక్ట్ అవ్వండి",
  connectDesc: "బుకింగ్స్‌ను ధృవీకరించడానికి మరియు ప్రయాణం సులభంగా సాగడానికి గెస్ట్లతో కమ్యూనికేట్ చేయండి.",
  payTitle: "సంపాదించండి",
  payDesc: "ప్రతి షేర్ చేసిన రైడ్ కోసం సురక్షితంగా సంపాదించండి, అలాగే మీ వాహనాన్ని గరిష్టంగా ఉపయోగించండి.",
  travelTitle: "డ్రైవ్ చేయండి",
  travelDesc: "రియల్ టైమ్ ట్రాకింగ్ మరియు గెస్ట్ రేటింగ్స్ వంటి ఫీచర్స్‌తో సురక్షితమైన, నమ్మదగిన రైడ్‌లను అందించండి.",
  GuestsectionSubtitle: 'మీ ప్రయాణ అనుభవాన్ని మార్చే నాలుగు సులభమైన స్టెప్స్ — గెస్ట్‌గా',
  GuestsearchTitle:'వెతకండి',
  GuestsearchDesc:'మీ రూట్ మరియు సమయానికి సరిపోయే ధృవీకృత హోస్ట్స్ ఇచ్చిన రైడ్‌లను సులభంగా కనుగొనండి.',
  GuestconnectTitle:'కనెక్ట్ అవ్వండి',
  GuestconnectDesc:'పిక్-అప్ పాయింట్లు మరియు ప్రయాణ వివరాలను సురక్షితంగా సమన్వయించడానికి హోస్ట్లతో నేరుగా చాట్ చేయండి.',
  GuestpayTitle:'చెల్లించండి',
  GuestpayDesc:'మీ రైడ్ బుక్ చేసుకుని, ఖర్చును సులభంగా పంచుకుని, సురక్షితంగా చెల్లించండి.',
  GuesttravelTitle:'ప్రయాణించండి',
  GuesttraveDesc:'రియల్ టైమ్ ట్రాకింగ్ మరియు రైడ్ సపోర్ట్‌తో సౌకర్యవంతమైన, సురక్షితమైన ప్రయాణాన్ని ఆస్వాదించండి.'

  },
  testimonials: {
    sectionTitle: 'మా సముదాయ కథలు',
    sectionSubtitle: "నిజమైన ప్రయాణికుల నుండి నిజమైన అనుభవాలు – పంచుకునే ప్రయాణాల ఆనందాన్ని కనుగొన్నవారు.",
    averageRating: 'సగటు రేటింగ్',
    recommendUs: 'మమ్మల్ని సిఫార్సు చేస్తారు',
    happyTravelers: 'సంతోషంగా ఉన్న ప్రయాణికులు',
    customerSupport: 'కస్టమర్ సపోర్ట్',
    trustedBy: 'ఈ సంస్థల ఉద్యోగులు నమ్మారు',
    items: [
      JSON.stringify({
        name: 'చంద్రశేఖర్ పీచెవార్',
        role: 'సాఫ్ట్‌వేర్ ఇంజనీర్',
        location: 'ముంబయి → పుణె మార్గం',
        rating: 5,
        text: "నేను గత 6 నెలల్లో నా వారంవారీ ముంబై-పూనే ప్రయాణాల కోసం రైడ్‌షేరింగ్‌ను ఉపయోగించి ₹8,000 కంటే ఎక్కువను ఆదా చేసాను. ఈ యాప్ ధృవీకరించబడిన హోస్ట్‌లతో మరియు సులభమైన బుకింగ్‌తో అత్యంత నమ్మకమైన కార్‌పూల్ యాప్.",
        avatar: '👩‍💼',
        savings: '₹8,000 ఆదా'
      }),
      JSON.stringify({
        name: 'రాజ్ పటేల్',
        role: 'వ్యాపార అధికారి',
        location: 'ఢిల్లీ → జైపూర్ మార్గం',
        rating: 5,
        text: "నాకు నెలకు రెండుసార్లు జైపూర్ వెళ్లాల్సి వస్తుంది. ఈ ప్లాట్‌ఫామ్ వల్ల ప్రయాణం చాలా సులభమైంది. మంచి స్నేహితులు, నమ్మదగిన సేవ, పర్యావరణానికి కూడా మేలు చేస్తున్నాను!",
        avatar: '👨‍💼',
        savings: '60% ఖర్చు తగ్గింపు'
      }),
      JSON.stringify({
        name: 'అనిత రెడ్డి',
        role: 'కాలేజ్ విద్యార్థిని',
        location: 'బెంగళూరు → చెన్నై మార్గం',
        rating: 5,
        text: "రోజువారీ ప్రయాణ ఖర్చులను ఆదా చేయడానికి తక్కువ ఖర్చుతో కూడిన ట్రావెల్ యాప్ కోసం వెతుకుతున్న విద్యార్థులు మరియు వృత్తిపరుల కోసం పరిపూర్ణం. ఇప్పుడు తరచూ ఇంటికి వెళ్లగలను. భద్రతా ఫీచర్లు నా తల్లిదండ్రులకు నమ్మకం ఇస్తున్నాయి, ప్రయాణంలో మంచి స్నేహితులు కూడా కలిశాను.",
        avatar: '👩‍🎓',
        savings: 'ప్రతి సంవత్సరం ₹12,000 ఆదా'
      }),
      JSON.stringify({
        name: 'విక్రమ్ సింగ్',
        role: 'మార్కెటింగ్ మేనేజర్',
        location: 'హైదరాబాద్ → విజయవాడ మార్గం',
        rating: 5,
        text: "కో-ప్యాసింజర్ల నాణ్యత అద్భుతం. అర్థవంతమైన సంభాషణలు, బిజినెస్ నెట్‌వర్కింగ్ అవకాశాలు కూడా దొరికాయి. ఇది కేవలం డబ్బు ఆదా మాత్రమే కాదు.",
        avatar: '👨‍💻',
        savings: 'కొత్త పరిచయాలు'
      })
    ]
  },
  topBar:{
  welcomeMessage: "డ్యూరీ రైడ్‌షేరింగ్‌కి స్వాగతం — పరిశీలించబడిన గెస్ట్‌లు మరియు హోస్ట్‌లతో సురక్షితంగా, నమ్మకంగా చేసే ప్రయాణం"
  },
};
export default te; 